var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainContainer"},[_c('p',{staticClass:"PercentageBar-span"},[_vm._v("\n    "+_vm._s(_vm.formattedPercentage)+"%\n  ")]),_vm._v(" "),_c('div',{staticClass:"main bar",attrs:{"id":"mainBar"}},[_c('div',{ref:"percentage",staticClass:"percentaje bar",style:([{ backgroundColor : _vm.anotherColor }])})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-053d332a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PercentageBar.vue
// module id = 1279
// module chunks = 1